import { withRBAC } from "../rbac";
import { GRNCreate } from './GRNCreate';
import { GRNEdit } from './GRNEdit';
import { GRNItemEdit } from './GRNItemEdit';
import { GRNList } from './GRNList';
import { GRNShow } from './GRNShow';

export const goods_receipts = {
    list: withRBAC(GRNList, "view_procurement"),
    show: withRBAC(GRNShow, "view_procurement"),
    create: withRBAC(GRNCreate, "manage_procurement"),
    edit: withRBAC(GRNEdit, "manage_procurement"),
};

export const grn_items = {
    edit: withRBAC(GRNItemEdit, "manage_procurement"),
};
